import { render, staticRenderFns } from "./PearsonLogo.vue?vue&type=template&id=97a984da&scoped=true"
import script from "./PearsonLogo.vue?vue&type=script&lang=js"
export * from "./PearsonLogo.vue?vue&type=script&lang=js"
import style0 from "./PearsonLogo.vue?vue&type=style&index=0&id=97a984da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a984da",
  null
  
)

export default component.exports